export const initialState = (inputResponse: any, isEdit = false) => {
  console.log("inputResponse", inputResponse);
  return {
    developerId: {
      value: inputResponse?.developer_name ?? "",
      id: inputResponse.developerId ?? "",
      error: "",
    },
    projectId: {
      value: inputResponse?.project_name ?? "",
      id: inputResponse.projectId ?? "",
      error: "",
    },
    countryId: {
      value: inputResponse?.country_name ?? "",
      id: inputResponse.countryId ?? "",
      error: "",
    },
    stateId: {
      value: inputResponse?.state_name ?? "",
      id: inputResponse.stateId ?? "",
      error: "",
    },
    city: { value: inputResponse.city ?? "", error: "" },
    zipcode: { value: inputResponse.zipcode ?? "", error: "" },
    projectDetailId: {
      value: (inputResponse?.projectDetailId || inputResponse?._id) ?? "",
      error: "",
    },
    description: { value: inputResponse.description ?? "", error: "" },
    AssignTo:""
  };
};

export const handleValidation = (rawInput: any) => {
  if (rawInput.developerId.id === "") {
    rawInput.developerId.error = "Please select developer name";
  }
  if (rawInput.projectId.id === "") {
    rawInput.projectId.error = "Please select project name";
  }
  if (rawInput.countryId.id === "") {
    rawInput.countryId.error = "Please select country";
  }
  if (rawInput.stateId.id === "") {
    rawInput.stateId.error = "Please select state";
  }
  if (rawInput.city.value === "") {
    rawInput.city.error = "Please enter city";
  }
  if (rawInput.zipcode.value === "") {
    rawInput.zipcode.error = "Please enter zipcode";
  }
  if (rawInput.description.value === "") {
    rawInput.description.error = "Please enter description";
  }
  return rawInput;
};

export const validateInput = (name: any, value: any) => {
  if (name === "zipcode") {
    if (!/^[0-9]+$/.test(value) || value.length > 6) {
      return false;
    }
  }

  if (name === "description") {
    if (!/^[a-zA-Z0-9\s.,-]+$/.test(value) && value !== "") {
      return false;
    }
  }

  return true;
};

export const getFinalBodyStructure = (inputBody: any) => {
  let finalBody = {};
  for (const key in inputBody) {
    finalBody = {
      ...finalBody,
      [key]: ["developerId", "projectId", "countryId", "stateId"].includes(key)
        ? inputBody[key].id
        : inputBody[key].value,
    };
  }
  const newObj: any = { ...finalBody };
  return newObj;
};


export const validatePersonalDetail = (data: any) => {
  const errors: Record<string, string> = {};

  if (!data.countryId) {
    errors.countryId = "Country is required";
  }
  if (!data.stateId) {
    errors.stateId = "State is required";
  }
  if (!data.city) {
    errors.city = "City is required";
  }
  // if (!data.zipcode) {
  //   errors.zipcode = "Zipcode is required";
  // } else if (!/^\d{5,6}$/.test(data.zipcode)) {
  //   errors.zipcode = "Enter a valid zipcode";
  // }
  // if (!data.fullAddress) {
  //   errors.fullAddress = "Address is required";
  // }
  if (!data.projectId && !data.project_name) {
    errors.projectId = "Project Name is required";
  }

  return errors;
};
